import { LocalStorageDic } from '@/config';

const goPassport = (route: string) => {
  localStorage.removeItem(LocalStorageDic.isLogin);
  window.location.href = route;
};

export default goPassport;
